<div class="prepare-file-drop-container" (scroll)="onSmallDeviceScroll($event)">
    <ng-container [ngSwitch]="(rawFilesError$ | async)?.type">
        <div *ngSwitchCase="'DUPLICATE_FILES'" class="alert-message-container">
            <div class="alert-message">
                <span translate>UPLOADER_ERROR_SAME_NAME</span>
            </div>
        </div>
        <div *ngSwitchCase="'FORBIDDEN_FILE_EXTENSION'" class="alert-message-container">
            <div class="alert-message">
                <span translate>UPLOADER_ERROR_FORBIDDEN_FILE_EXTENSION</span>
            </div>
        </div>
        <div *ngSwitchCase="'RELATIVEPATH_TOO_LONG'" class="alert-message-container">
            <div class="alert-message">
                <span translate>UPLOADER_ERROR_RELATIVEPATH_TOO_LONG</span>
            </div>
        </div>
        <div *ngIf="(uploadError$ | async)?.name === 'InvalidAvailabilityDurationError'" class="alert-message-container">
            <div class="alert-message">
                <span  translate>UPLOADER_GENERIC_ERROR</span>
            </div>
        </div>
    </ng-container>
    <app-smash-file-drop (fileDrop)="dropped($event)" (entryReadError)="onEntryReadError()" (fileOver)="fileOver()" (fileLeave)="fileLeave()">
        <ng-template>
            <div class="prepare-container">
                <div class="prepare-subcontainer">
                    <app-upload-files-box 
                        [files]="rawFiles$ | async" 
                        [totalToUpload]="totalSizeToUpload$ | async">
                    </app-upload-files-box>
                    <app-upload-parameters-box
                        [dropbox]="dropbox$ | async"
                        [isDropboxId]="isDropboxId"
                        [uploadFormMode]="uploadFormMode$ | async"
                        [canConfigSmash]="(canConfigSmash$ | async)" 
                        [transferSettings]="(transferSettings$ | async)">
                    </app-upload-parameters-box>
                </div>
            </div>
        </ng-template>
    </app-smash-file-drop>
</div>
